import {configContainer, statusContainer, utils} from '@wallaby-ui/core';

import * as at from './file_action_types';
import {LIBRARY_NAME} from 'src/js/common/constants';
import FileFetcher from 'src/js/fetchers/file_fetcher';
import {DocumentConfig} from 'src/js/model/document_config';
import {File} from 'src/js/model/file';
// import mockData from 'src/js/model/file_mock.json';
import {TableConfig} from 'src/js/model/table_config';

const logger = utils.LogUtils.getLogger('FileActions', LIBRARY_NAME);

export function closeFile(stateId) {
  return (dispatch) => dispatch({type: at.CLOSE_FILE, stateId});
}

export function changeFile(stateId, file) {
  return (dispatch) => dispatch({type: at.CHANGE_FILE, payload: file, stateId});
}

export function fetchFile(stateId, requestUrl, fileId) {
  return (dispatch) => {
    dispatch({type: at.FILE_FETCH, stateId});

    return FileFetcher.get(requestUrl, fileId)
      .then((response) => {
        const file = new File(response);
        dispatch({
          type: at.FILE_FETCH_SUCCESS,
          payload: {file, fileId},
          stateId,
        });
      })
      .catch((error) => {
        logger.error(`FILE_FETCH_FAILURE: ${error}`);
        dispatch(statusContainer.addError(error, at.FILE_FETCH_FAILURE));
        dispatch({type: at.FILE_FETCH_FAILURE, payload: error, stateId});
      });
  };
}

export function setResultDetailConfig(stateId, data, reload = false) {
  const config = new DocumentConfig(data);
  return (dispatch) =>
    dispatch({
      type: at.SET_RESULT_DETAIL_CONFIG,
      payload: {config, reload},
      stateId,
    });
}

export function loadResultDetailConfig(
  filesStateId,
  requestUrl,
  configStateId,
  reload = false
) {
  return (dispatch, getState) =>
    dispatch(configContainer.actions.getConfig(configStateId, requestUrl)).then(
      () => {
        const config = getState()[configStateId].config[requestUrl];
        return dispatch(setResultDetailConfig(filesStateId, config, reload));
      }
    );
}

export function setResultDetailProjectConfig(stateId, data, reload = false) {
  const config = new DocumentConfig(data);
  return (dispatch) =>
    dispatch({
      type: at.SET_RESULT_DETAIL_PROJECT_CONFIG,
      payload: {config, reload},
      stateId,
    });
}

export function loadResultDetailProjectConfig(
  filesStateId,
  requestUrl,
  configStateId,
  reload = false
) {
  return (dispatch, getState) =>
    dispatch(configContainer.actions.getConfig(configStateId, requestUrl)).then(
      () => {
        const config = getState()[configStateId].config[requestUrl];
        return dispatch(
          setResultDetailProjectConfig(filesStateId, config, reload)
        );
      }
    );
}

export function setTableConfig(stateId, data, configId, reload = false) {
  const config = new TableConfig(data, configId);
  return (dispatch) =>
    dispatch({
      type: at.SET_TABLE_CONFIG,
      payload: {config, reload},
      stateId,
    });
}

export function loadTableConfig(
  filesStateId,
  requestUrl,
  configStateId,
  reload = false
) {
  return (dispatch, getState) =>
    dispatch(configContainer.actions.getConfig(configStateId, requestUrl)).then(
      () => {
        const config = getState()[configStateId].config[requestUrl];
        return dispatch(
          setTableConfig(filesStateId, config, requestUrl, reload)
        );
      }
    );
}
